<template>
  <template v-if="status === 'notRequested'">
    <span
      class="status-list__badge is-waiting"
      :data-test="dataTest"
    >
      <v-icon
        class="status-list__icon"
        size="16"
      >mdi-checkbox-blank-circle-outline</v-icon>
      未添削
    </span>
  </template>

  <template v-else-if="status === 'requested'">
    <span
      class="status-list__badge is-requested"
      :data-test="dataTest"
    >
      <v-icon
        class="status-list__icon"
        size="16"
      >mdi-bell-ring-outline</v-icon>
      呼び出し中
    </span>
  </template>

  <template v-else-if="status === 'started'">
    <span
      class="status-list__badge is-started"
      :data-test="dataTest"
    >
      <v-progress-circular
        class="status-list__spinner"
        color="correctionBlue"
        indeterminate
        :size="14"
        :width="2"
      />
      添削中
    </span>
  </template>

  <template v-else-if="status === 'suggestionPending'">
    <span
      class="status-list__badge is-warning"
      :data-test="dataTest"
    >
      <v-icon
        class="status-list__icon"
        size="16"
      >mdi-alert-circle-outline</v-icon>
      指摘あり
    </span>
  </template>

  <template v-else-if="status === 'suggestionResolved' || status === 'noSuggestion'">
    <span
      class="status-list__badge is-completed"
      :data-test="dataTest"
    >
      <v-icon
        class="status-list__icon"
        size="16"
      >mdi-check-circle-outline</v-icon>
      確認完了
    </span>
  </template>

  <template v-else-if="status === 'failed'">
    <span
      class="status-list__badge is-failed"
      :data-test="dataTest"
    >
      <v-icon
        class="status-list__icon"
        size="16"
      >mdi-reload-alert</v-icon>
      エラー発生
    </span>
  </template>

  <template v-else-if="status === 'noQuestions'">
    <span
      class="status-list__badge is-no-questions"
      :data-test="dataTest"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.20406 14.6663H3.9974C3.2574 14.6663 2.66406 14.073 2.66406 13.333V2.66634C2.66406 1.93301 3.2574 1.33301 3.9974 1.33301H9.33073L13.3307 5.33301V8.72634C13.1107 8.69301 12.8907 8.66634 12.6641 8.66634C12.4374 8.66634 12.2174 8.69301 11.9974 8.72634V5.99967H8.66406V2.66634H3.9974V13.333H8.72406C8.80406 13.813 8.97073 14.2597 9.20406 14.6663ZM15.0241 14.0797L13.6041 12.6663L15.0241 11.253L14.0774 10.313L12.6641 11.7263L11.2507 10.313L10.3107 11.253L11.7241 12.6663L10.3107 14.0797L11.2507 15.0263L12.6641 13.6063L14.0774 15.0263L15.0241 14.0797Z"
          fill="white"
        />
      </svg>
      <span class="status-list__badge-text">疑問点がないため添削対象外</span>
    </span>
  </template>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  status: {
    type: String,
    required: true,
  },
});

const dataTest = computed(() => `correction-status-pill-${props.type}`);
</script>

<style scoped lang="scss">
.status-list__badge {
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex-shrink: 0;
}

.status-list__icon {
  line-height: 1;
}

.status-list__spinner {
  margin: 0;
}

.status-list__badge.is-waiting {
  background: #F8F8F8;
  color: #797979;
}

.status-list__badge.is-requested {
  background: #edf5ff;
  color: #2563eb;
}

.status-list__badge.is-started {
  background: #dbeafe;
  color: #1d4ed8;
}

.status-list__badge.is-warning {
  background: #fee2e2;
  color: #dc2626;
}

.status-list__badge.is-completed {
  background: #dbeafe;
  color: #1d4ed8;
}

.status-list__badge.is-failed {
  background: #fee2e2;
  color: #b91c1c;
}

.status-list__badge.is-no-questions {
  background: #A5A5A5;
  color: #fff;
}

.status-list__badge-text {
  font-size: 12px;
  font-weight: 600;
}
</style>
